import React, { useEffect, useState } from "react";
import { RecepcionTrasladoApi } from "../api/RecepcionTrasladoApi";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import Swal from "sweetalert2";
import { UNIDAD_MEDIDA } from "../../../../../../../utility/constants";
import { buildResumenMateriaPrima } from "../../../helpers/groupProductos";
import { TrasladosApi } from "../../../api/TrasladosApi";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

export const useRecepcionTraslado = (
    traslado_id,
    navigateToDetail,
    validateForm,
    formGetValues,
) => {
    const { crearRecepcionTraslado, cargando } = RecepcionTrasladoApi();

    const { getTrasladoDetalle, cargando: cargandoDetalle } = TrasladosApi();

    const [trasladoDetalle, setTrasladoDetalle] = useState({});

    const GetTrasladoDetalle = async () => {
        try {
            const traslado_detalle = await getTrasladoDetalle(traslado_id);

            const resumenMateriaPrima = buildResumenMateriaPrima(
                traslado_detalle.detalles,
                traslado_detalle,
            );

            const newData = {
                ...traslado_detalle,
                detalles: resumenMateriaPrima,
            };

            setTrasladoDetalle(newData);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del traslado",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
            setTrasladoDetalle({});
        }
    };

    useEffect(() => {
        GetTrasladoDetalle();
    }, [traslado_id]);

    const CrearRecepcionTraslado = async () => {
        if (!trasladoDetalle) return;

        const isFormValid = await validateForm();
        if (!isFormValid) {
            NotificationManager.error(
                "Por favor, complete todos los campos requeridos.",
                "Error",
                3000,
            );
            return;
        }

        // Si no hay finca asociada mostrar error
        if (
            !trasladoDetalle.acopio_origen ||
            !trasladoDetalle.acopio_origen.finca_asociada
        ) {
            NotificationManager.error(
                "El acopio de origen no tiene una finca asociada. No se puede crear la recepción del traslado.",
                "Error",
                5000,
            );
            return;
        }

        // Si no hay tipo de materia prima mostrar error
        if (
            !trasladoDetalle.detalles ||
            trasladoDetalle.detalles.length === 0 ||
            !trasladoDetalle.detalles[0].materia_prima ||
            !trasladoDetalle.detalles[0].materia_prima.tipo_materia_prima
        ) {
            NotificationManager.error(
                "No se pudo determinar el tipo de materia prima del traslado.",
                "Error",
                5000,
            );
            return;
        }

        const fecha = trasladoDetalle.fecha_recepcion
            ? moment(trasladoDetalle.fecha_recepcion).format("YYYY-MM-DD HH:mm")
            : moment().format("YYYY-MM-DD HH:mm");
        const fecha_analisis = trasladoDetalle.fecha_recepcion
            ? moment(trasladoDetalle.fecha_recepcion).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD");
        const hora = trasladoDetalle.fecha_recepcion
            ? moment(trasladoDetalle.fecha_recepcion).format("HH:mm")
            : moment().format("HH:mm");

        const peso_bruto = formGetValues("peso_bruto");

        const body = {
            traslado_id: trasladoDetalle.id,
            traslado_numero: trasladoDetalle.numero,
            fecha: fecha,
            fecha_analisis: fecha_analisis,
            finca: trasladoDetalle.acopio_origen.finca_asociada.id,
            hora_analisis: hora,
            hora_ingreso: hora,
            // Se aproxima al decimal más cercano
            peso_bruto: Math.round(peso_bruto),
            piloto: trasladoDetalle.piloto.id,
            productos: trasladoDetalle.detalles.map((detalle, index) => ({
                index: index,
                materia_prima: detalle.materia_prima.id,
                // se usan los kg de salida del traslado como peso finca
                // para registros antiguos que no tienen pesaje se usan los kg humedos
                peso_finca: detalle.yaPesado
                    ? detalle.pesaje.peso_neto
                    : detalle.kilos_humedos,
                peso_finca_kg: detalle.yaPesado
                    ? detalle.pesaje.peso_neto
                    : detalle.kilos_humedos,
                peso_finca_unidad: UNIDAD_MEDIDA.KILOGRAMO,
            })),
            tipo_materia:
                trasladoDetalle.detalles[0].materia_prima.tipo_materia_prima.id,
            vehiculo: trasladoDetalle.vehiculo.id,
        };

        try {
            const recepcionTraslado = await crearRecepcionTraslado(body);

            NotificationManager.success(
                "Recepción de traslado creada exitosamente",
                "Éxito",
                3000,
            );

            // Redirigir al detalle de la recepción creada
            navigateToDetail(recepcionTraslado.id);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear la recepción del traslado.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return {
        trasladoDetalle,
        CrearRecepcionTraslado,
        cargando: cargando || cargandoDetalle,
    };
};
